import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type Variant = 'high' | 'medium' | 'low';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadialProgressBar',
  props: {
    size: { default: 100 },
    total: null,
    count: null,
    ringThickness: { default: 8 },
    variant: { default: 'high' }
  },
  setup(__props: any) {

const props = __props as { size: number, total: number, count: number, ringThickness: number, variant: Variant };



const VARIANT_CLASSES = {
  high: {
    ring: 'tw:text-vuln-high',
    background: 'tw:text-vuln-high-light',
  },
  medium: {
    ring: 'tw:text-vuln-medium',
    background: 'tw:text-vuln-medium-light',
  },
  low: {
    ring: 'tw:text-vuln-low',
    background: 'tw:text-vuln-low-light',
  },
};

const classes = computed(() => VARIANT_CLASSES[props.variant]);
const progress = computed(() => (props.total > 0 ? (props.count / props.total) * 100 : 0));
const radius = computed(() => (100 - props.ringThickness) / 2);
const circumference = computed(() => +(2 * Math.PI * radius.value).toFixed(1));
const strokeDashOffset = computed(
  () => circumference.value - (circumference.value * progress.value) / 100
);

return { __sfc: true,props, VARIANT_CLASSES, classes, progress, radius, circumference, strokeDashOffset }
}

})